import { render, staticRenderFns } from "./dr-wrapper.vue?vue&type=template&id=61ccc9e3"
import script from "./dr-wrapper.vue?vue&type=script&lang=js"
export * from "./dr-wrapper.vue?vue&type=script&lang=js"
import style0 from "./dr-wrapper.vue?vue&type=style&index=0&id=61ccc9e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports